import { send } from '../../../../../../../../src/network';
import { type OrderShuffle } from '../../../../../../../../src/types/OrderShuffle';

type Params = {
  orderId: number;
};

/**
 * Warning!!!!!
 *
 * This hook has a side effect of triggering a shuffle on the order that you're fetching if the order isn't already shuffled.
 *
 * This can lead to side effects of shuffling an order too early, like when we're still collecting onboarding information.
 *
 * Be very careful about where you use this hook and, if you do use it, regression test the onboarding flow.
 */
export async function getApiV2CustomersCustomerIdOrdersOrderIdIsShuffling(
  params: Params
) {
  return await send<OrderShuffle>({
    path: `/api/v2/customers/self/orders/${params.orderId}/is_shuffling/`,
    method: 'GET',
  });
}
